import toastr from "toastr";

toastr.options = {
    // "positionClass": "toast-bottom-right",
    preventDuplicates: true
}

export function showNotification(title, message = "", type = 'info') {

    toastr[type](title, message)
}
